import React from 'react'
import { Button } from 'antd'
import { FileAddOutlined } from '@ant-design/icons'

export default (props) => {
  return (
    <Button icon={<FileAddOutlined />} type={'primary'} size='large' onClick={props.onClick} style={{ verticalAlign: 'middle' }}>
      Add new
    </Button>
  )
}
